import { type FC, type ReactNode } from 'react';

import { cn } from '@/components/TailwindComponents/lib/utils';

interface PageHeaderActionProps {
  children: ReactNode;
  className?: string;
  position?: 'left' | 'center' | 'right';
}

export const PageHeaderAction: FC<PageHeaderActionProps> = ({
  children,
  className,
  position = 'right',
}) => {
  return (
    <div
      data-position={position}
      className={cn('flex items-center mx-2', className)}
    >
      {children}
    </div>
  );
};

PageHeaderAction.displayName = 'PageHeaderAction';
